import { render } from "./PositionComponent.vue?vue&type=template&id=4b75d2fc"
import script from "./PositionComponent.vue?vue&type=script&lang=js"
export * from "./PositionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__